import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import VisIcon from '../../../images/submenu_open copy 6.png'
import NavigateIcon from '../../../images/submenu_open copy 5.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'
import WarningIcon from '../../../images/advarsel2.png'

class Festegrunn extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleFestegrunn = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    navigateFestegrunn = (event) => {
        event.stopPropagation()
        this.props.onMatrikkelObjectSelected({
            domainKlasse: "Matrikkelenhet",
            matrikkelenhet: this.props.festegrunn
        })
    }

    showFestegrunn = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowFestegrunn,
                festegrunn: this.props.festegrunn
            }
        })
    }

    render() {
        const { t } = this.props
        var festegrunn = this.props.festegrunn
        var matrikkelnummer = `${festegrunn.gardsnummer}/${festegrunn.bruksnummer}`;
        if (festegrunn.festenummer || festegrunn.seksjonsnummer) matrikkelnummer += `/${festegrunn.festenummer}/${festegrunn.seksjonsnummer}`;
        var infoList = []
        if (festegrunn.utgatt) infoList.push(t('utgatt'))
        if (!festegrunn.harTeig) infoList.push(t('manglerteig'))

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleFestegrunn}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{festegrunn.kommuneId}-{matrikkelnummer}</span>
                    { infoList.length > 0 &&
                    <div className="icon-image tooltip warning">
                        <img src={WarningIcon} />
                        <div className="tooltip-content">
                            {infoList.map((i, index) => { return (<div key={index}>{i}</div>) })}
                        </div>
                    </div> }
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    <div className="icon-image right tooltip" onClick={this.navigateFestegrunn}>
                        <img className="tool" src={NavigateIcon} />
                        <div className="tooltip-content">{t('naviger.festegrunn')}</div>
                    </div>
                    { festegrunn.harTeig &&
                    <div className="icon-image right tooltip" onClick={this.showFestegrunn}>
                        <img className="tool" src={VisIcon} />
                        <div className="tooltip-content">{t('vis.festegrunn')}</div>
                    </div> }
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{festegrunn.kommunenavn} ({festegrunn.kommuneId})</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('eiendom')}</div>
                            <div className="value">{matrikkelnummer}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Festegrunn)